module.exports = __webpack_public_path__ + "img/highHat.caec2be9.svg";